// Mobile PDP carousel — ported from Turn-shopify src/js/main.js
// Keep in sync with $pdp-mobile-max in src/scss/themes/_pdp.scss (1023px; desktop from 1024px)
const PDP_MOBILE_MAX_WIDTH = 1023;

export function destroyPdpSlick() {
  const jQuery = window.jQuery;
  if (!jQuery) return;

  jQuery(".template-product .product_images_all .img-all").each(function () {
    const $gallery = jQuery(this);
    if (
      $gallery.hasClass("slick-initialized") &&
      typeof $gallery.slick === "function"
    ) {
      try {
        $gallery.slick("unslick");
      } catch {
        // ignore
      }
    }
  });
}

function initializeMobileCarousel() {
  function initCarousel() {
    destroyPdpSlick();

    const carouselContainers = document.querySelectorAll(
      ".pdp-mobile-gallery .swiper-container.mobile-only",
    );

    carouselContainers.forEach((container) => {
      if (container.dataset.carouselInitialized === "true") return;

      const wrapper = container.querySelector(".swiper-wrapper");
      const slides = container.querySelectorAll(".swiper-slide");

      if (!wrapper || slides.length === 0) return;

      container.dataset.carouselInitialized = "true";

      let currentSlide = 0;
      const totalSlides = slides.length;

      function updateSlidePosition() {
        const containerWidth = container.offsetWidth;
        if (!containerWidth) return;

        const totalSlideSpace = 100 - (12 / containerWidth) * 100;
        const translateX = -currentSlide * totalSlideSpace;
        wrapper.style.transform = `translateX(${translateX}%)`;

        const sectionId = container.id.replace("swiper-gallery-", "");
        const counter = document.querySelector(
          `#MediaGallery-${sectionId}-mobile .current_image`,
        );
        if (counter) {
          counter.textContent = String(currentSlide + 1);
        }
      }

      function goToSlide(slideIndex) {
        currentSlide = Math.max(0, Math.min(slideIndex, totalSlides - 1));
        updateSlidePosition();
      }

      function nextSlide() {
        goToSlide(currentSlide + 1);
      }

      function prevSlide() {
        goToSlide(currentSlide - 1);
      }

      let startX = 0;
      let isDragging = false;

      container.addEventListener("touchstart", (e) => {
        if (e.touches?.[0]) {
          startX = e.touches[0].clientX;
          isDragging = true;
        }
      });

      container.addEventListener("touchmove", (e) => {
        if (!isDragging || !e.touches?.[0]) return;
        const diffX = startX - e.touches[0].clientX;

        if (Math.abs(diffX) > 50) {
          if (diffX > 0) nextSlide();
          else prevSlide();
          isDragging = false;
        }
      });

      container.addEventListener("touchend", () => {
        isDragging = false;
      });

      updateSlidePosition();

      window.requestAnimationFrame(() => {
        updateSlidePosition();
      });
    });
  }

  function handleResize() {
    if (window.innerWidth <= PDP_MOBILE_MAX_WIDTH) {
      initCarousel();
    }
  }

  handleResize();
  window.addEventListener("resize", handleResize);
}

export function initPdpMobileCarousel() {
  destroyPdpSlick();
  initializeMobileCarousel();
}
